(function () {
  function initSlider(slider) {
    var track = slider.querySelector('[data-cr-featured-track]');
    var prev = slider.querySelector('[data-cr-featured-prev]');
    var next = slider.querySelector('[data-cr-featured-next]');

    if (!track || !prev || !next) {
      return;
    }

    function getStep() {
      var card = track.querySelector('.cr-card');
      var gap = parseFloat(window.getComputedStyle(track).columnGap || 0);

      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;

      if (maxScroll <= 0) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }

      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= maxScroll;
    }

    function updateMobileActiveCard() {
      var cards = track.querySelectorAll('.cr-card');

      if (!window.matchMedia('(max-width: 749px)').matches) {
        cards.forEach(function (card) {
          card.classList.remove('cr-card--mobile-active');
        });
        return;
      }

      var step = getStep();
      var activeIndex = step ? Math.round(track.scrollLeft / step) : 0;
      activeIndex = Math.max(0, Math.min(activeIndex, cards.length - 1));

      cards.forEach(function (card, index) {
        card.classList.toggle('cr-card--mobile-active', index === activeIndex);
      });
    }

    function updateSliderState() {
      updateButtons();
      updateMobileActiveCard();
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateSliderState, { passive: true });
    window.addEventListener('resize', updateSliderState);
    updateSliderState();
  }

  function initCustomerReviewFeatured() {
    document.querySelectorAll('[data-cr-featured-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomerReviewFeatured);
  } else {
    initCustomerReviewFeatured();
  }
})();
